var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("radio-checkbox-collection", {
    attrs: {
      "enabled-options": _vm.supportedTagRouteTypes,
      options: [
        {
          value: _vm.TAG_TYPES.GOAL,
          label: _vm.resource("JourneyBuilder_Sankey_Goal_Label")
        },
        {
          value: _vm.TAG_TYPES.OUTFLOW,
          label: _vm.resource("JourneyBuilder_Sankey_Outflow_Label")
        }
      ]
    },
    model: {
      value: _vm.valueModel,
      callback: function($$v) {
        _vm.valueModel = $$v
      },
      expression: "valueModel"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }